import { ComponentElem } from "@components/interfaces";
import ViewportRoot, { getViewportName } from "@ts/sframe/ViewportRoot";
import PopupBase from "./PopupBase";
import Popups from "./Popups";
import MemberOptionsBlock from "../shared/MemberOptionsBlock";
import { Common } from "../common/CommonTypes";
import ApiProxy from "../../ts/ApiProxy";
import Tools from "../../ts/Tools";

export default class MemberOptions extends PopupBase
{
  static instance: MemberOptions;

  autoClose_popup: boolean = true;

  popupAlign = 4;

  constructor(elem: ComponentElem)
  {
    super(elem);
    MemberOptions.instance = this;

    MemberOptionsBlock.init(this.$root);

    this.$root.find(".qa").on("click", (event:JQuery.ClickEvent)=>
    {
      event.preventDefault();
      Popups.closeMenu();      
    });
  }

  open(targetElem: HTMLElement)
  {
    if(getViewportName() === "mobile")
    {
      Popups.to("member-options");
    }
    else
    {      
      Popups.openMenu("member-options", targetElem, {position: "sticky", align: "right", offsetTop: 14, offsetLeft: 25});
    }
  }

  updateName()
  {
    let data: Common.CommonPageData = ApiProxy.getCommonPageData();
    
    if(!data) return;

    let  info = data.login_state.info,
      name = Tools.combineName(info.basic.first_name, info.basic.surname);
    this.$root.find(`.name`).text(name);
  }
}